import { Component, Injectable, Input, OnDestroy, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { environment } from '@env/environment';
import {
  HttpClient,
  HttpParams,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';

const excelExportUrl = `${environment.apiBaseUrl}platform/export`;

@Injectable({
  providedIn: 'root'
})
export class ExportExcelDataService {
  constructor(private http: HttpClient) {}

  getDataList(params: HttpParams): Observable<any> {
    return this.http.get(`${excelExportUrl}`, { params });
  }

  downloadData(params: any, exportUrl: string): Observable<HttpResponse<Blob>> {
    return this.http.get(`${exportUrl}/${params.uid}`, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  deleteDownloadExportData(params, exportUrl: string): Observable<any> {
    return this.http.delete(`${exportUrl}/${params.uid}`);
  }

  createExport(params: any, exportUrl: any): Observable<any> {
    const payload = {
      ...params
    };
    return this.http.post(`${exportUrl}`, payload);
  }
}

@UntilDestroy()
@Component({
  selector: 'app-tableExportToExcel',
  template: `
    <div>
        <h2 class="section-title">{{ title }}</h2>
      <nz-upload
        nzListType="picture"
        [nzDownload]="downloadFile"
        [(nzFileList)]="fileList"
        class="custom-upload"
        [nzRemove]="deleteExportedData">
      </nz-upload>
      <nz-empty nzNotFoundImage="simple" *ngIf="fileList?.length == 0"></nz-empty>
        <button id="newExportDataButton" nzType="primary" [nzLoading]="isLoadingExport" nz-button class="export-button" (click)="exportData()">
          <span nz-icon nzType="upload"></span> New Export Data
        </button>
    </div>
  `,
  styles: [`
    .section-title {
        display: flex;
        justify-content: center;
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 15px;
        color: #1ED760FF;
    }
    .custom-upload {
      width: 100%;
      margin-bottom: 10px;
    }
    .export-button {
        display: block;
        margin: 20px auto 0;
    }
  `]
})
export class TableExportToExcelComponent implements OnInit, OnDestroy {
  @Input() title?: string;
  @Input() queryParams: any;
  @Input() createExportUrl: any;
  @Input() downloadExportUrl: any;
  intervalId:any;

  isLoadingExport = true;
  sorting: any = {};
  refreshRequest: any
  fileList: NzUploadFile[] = [];

  constructor(private exportExcelDataService: ExportExcelDataService) {}

  ngOnInit(): void {
    this.refreshRequest = setInterval(() => this.getDataList(this.queryParams), 5000);
  }

  getDataList(params: any) {
    this.exportExcelDataService.getDataList(params).subscribe(response => {
      const tmpList = [];
      response.forEach(item => {
        tmpList.push({
          uid: item.id,
          name: item.fileName,
          status:
            item.exportStatus === 'IN_PROGRESS'
              ? 'uploading'
              : item.exportStatus === 'COMPLETED'
                ? 'done'
                : 'error'
        });
      });
      this.fileList = tmpList;
      this.isLoadingExport =
        this.fileList.filter(item => item.status === 'uploading').length > 0;
    });
  }

  downloadFile = (file: NzUploadFile) => {
    this.exportExcelDataService
      .downloadData(file, this.downloadExportUrl)
      .subscribe(response => {
        const contentDisposition = response.headers.get('Content-Disposition');
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename=(.+)/);
          if (fileNameMatch && fileNameMatch.length > 1) {
            const fileName = fileNameMatch[1];
            const blob = new Blob([response.body], {
              type: 'application/octet-stream'
            });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
          }
        }
      });
  };

  deleteExportedData = (file: NzUploadFile) => {
    this.exportExcelDataService.deleteDownloadExportData(file, this.downloadExportUrl).subscribe(item => {
      this.fileList = this.fileList.filter(
        fileItem => fileItem.uid !== file.uid
      );
    });
    return true
  };

  exportData() {
    this.exportExcelDataService
      .createExport(this.queryParams, this.createExportUrl)
      .subscribe(response => {
        this.getDataList(this.queryParams);
      });
  }

  ngOnDestroy(): void {
    clearInterval(this.refreshRequest);
  }
}
